import { arkScope } from '@/api/workspace/endpoints/arkConfig.ts';
import type { StopLossOrder } from '@/store/orders/stopLoss/state.ts';

export const SavedStopLossOrderValidator = arkScope.type({
  type: "'StopLossOrder'",
  properties: {
    status: arkScope
      .type({ type: "'creating'" })
      .or({ type: "'pending'" })
      .or({ type: "'failed'", errorMessage: 'string' })
      .or({ type: "'submitted' | 'editing' | 'cancelled'", tradeId: 'string' }),
    clientWay: "'buy' | 'sell'",
    'notional?': 'number',
    notionalCurrencyIndex: '1 | 2',
    limitPrice: 'number?',
    'currencyPair?': {
      currency1: 'string',
      currency2: 'string',
      tiering: 'string?',
    },
    expiry: arkScope
      .type({ type: "'GoodTillCancelled'" })
      .or({ type: "'ExpiryDate'", 'date?': 'string', 'time?': 'string' }),
    trigger: '"Spot" | "BidOffer" | "RateOneTouch"',
    'notificationEmails?': 'string[]',
    isReadyToSubmit: 'boolean',
    clockOffset: 'number?',
    mode: "'EDIT' | 'VIEW'",
  },
  tileId: 'string',
  clientId: 'number?',
});

export type SavedStopLossOrder = typeof SavedStopLossOrderValidator.infer;
export const SavedStopLossOrder = {
  fromFxStopLossOrder: (fxTile: StopLossOrder, tileId: string): SavedStopLossOrder => ({
    type: 'StopLossOrder',
    properties: fxTile.properties,
    tileId,
    clientId: fxTile.clientId,
  }),
} as const;
